

































































import DialogoDeEdicaoDeCliente from '@/components/cliente/DialogoDeEdicaoDeCliente.vue';
import Confirmacao from '@/components/ui/Confirmacao.vue';
import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue';
import DialogoDeEdicaoDeAdquirente from '@/components/venda/DialogoDeEdicaoDeAdquirente.vue';
import { Adquirente, Cliente, Page, Pageable } from '@/models';
import { criarCliente } from '@/shareds/cliente-shareds';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import { FindAdquirenteUseCase, SaveAdquirenteUseCase } from '@/usecases';
import { CancelToken } from 'axios';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'

@Component({
	components: {
		DataTableDeCrudPaginado,
		DialogoDeEdicaoDeAdquirente,
		Confirmacao,
		DialogoDeEdicaoDeCliente,
	},
})
export default class TelaDeCadastroDeAdquirente extends Vue {
	@Ref() dataTablePaginado!: DataTableDeCrudPaginado
	@Ref() dialogoDeEdicaoDeAdquirente!: DialogoDeEdicaoDeAdquirente
	@Ref() dialogoDeConfirmacao!: Confirmacao
	@Ref() dialogoDeEdicaoDeCliente!: DialogoDeEdicaoDeCliente

	findAdquirenteUseCase = new FindAdquirenteUseCase()
	saveAdquirenteUseCase = new SaveAdquirenteUseCase()
	busca = ''
	adquirente: Adquirente[] = []
	carregando = false
	editando = false

	headers = [
		{ text: 'Adquirente', value: 'razaoSocialOuNome' },
		{ text: 'Código SiTef', value: 'codigoSitef' },
	]

	async buscarPagina(paginavel: Pageable, parametros: {
		busca?: string
	}, cancelToken: CancelToken): Promise<Page<Adquirente>> {
		const pagina = await this.findAdquirenteUseCase.findAll({
			...parametros,
			...paginavel,
		}, {
			cancelToken,
		})
		this.adquirente = pagina.content
		return pagina
	}

	
	abrirDialogoDeEditarAdquirente(indice: number) {
		try {
			if(!this.temRecurso('alterar', "adquirente")) {
				throw new Error('Necessário permissão para editar')
			}
			this.editando = true
			const adquirente = this.adquirente[indice]
			this.dialogoDeEdicaoDeAdquirente.mostrar(adquirente, true)
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	abrirDialogoDeCriarAdquirente(cadastroPadrao: boolean) {
		try {
			if(!this.temRecurso('criar', 'adquirente')) 
				throw new Error('Necessário permissão para criar')
			this.editando = true
			const adquirente = {id:"",razaoSocialOuNome:"",cnpjOuCpf:"",codigoSitef:null}

			if (cadastroPadrao){
				this.dialogoDeEdicaoDeAdquirente.mostrar(adquirente, cadastroPadrao)
			} else {
				const cliente = criarCliente()
				this.dialogoDeEdicaoDeCliente.mostrar(cliente, true)
			}
			
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	criarRegistro(adquirente: Adquirente) {
		this.adquirente.push(adquirente)
	}

	atualizarRegistro(adquirente: Adquirente) {
		const indice = this.adquirente.findIndex( adquirenteExistente => adquirenteExistente.id === adquirente.id)
		this.adquirente.splice(indice, 1, adquirente)
	}

	get temRecurso() {
		return UserLoginStore.temAutorizacaoPorOperacaoERecurso
	}

	@Watch('busca')
	novaBusca() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}

	@Watch('carregando')
	onChangeMostrar() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}

	confirmarCadastro() {
		this.dialogoDeConfirmacao.mostrar()
	}

	async criarRegistroDeAdquirenteComCliente(clienteSalvo: Cliente){
		const adquirente = {
			id:"",
			razaoSocialOuNome: clienteSalvo.razaoSocialOuNome.toUpperCase(),
			cnpjOuCpf:clienteSalvo.cnpjOuCpf,
			ativo: true,
			codigoSitef: null,
		}

		const adquirenteSalvo = await this.saveAdquirenteUseCase.create(adquirente)
		this.criarRegistro(adquirenteSalvo)
	}
}
